import { dashApi } from '../../../services/api'
import Config from '../../../configs'
import { SIGNUP_METHOD } from '../SignUpWrapper/SignUpWrapper.constants'

type VerifyUsernameEmailArgs = {
  country: string
  email: string
}

type VerifyUsernamePhoneArgs = {
  country: string
  contact: string
}

export const verifyUsernameEmail = async ({ country, email }: VerifyUsernameEmailArgs) => {
  return await dashApi.verifyUsername(
    {
      locale: country,
      systemId: country,
      callbackURL: `${Config.WEB_BASE_URL.replace('\r', '')}/v2/signup/password?country=${country}`,
      email: email,
      withOtp: true
    },
    SIGNUP_METHOD.EMAIL
  )
}

export const verifyUsernamePhone = async ({ country, contact }: VerifyUsernamePhoneArgs) => {
  return await dashApi.verifyUsername(
    {
      locale: country,
      systemId: country,
      contact,
      withotp: true
    },
    SIGNUP_METHOD.PHONE
  )
}
